import "@radix-ui/themes/styles.css";
import { RouteProvider } from "../routing/router.ts";
import { ConvexClientProvider } from "../common/ConvexClientProvider.tsx";
import { Toaster } from "sonner";
import { Routes } from "../routing/Routes.tsx";
import { ensure } from "@repo/shared/utils/ensure.ts";
import { CommonDialogsProvider } from "../common/CommonDialogsProvider.tsx";
import { StashItTheme } from "./StashItTheme.tsx";
import { useAppearance } from "./appearance.ts";
import { useIsSm } from "../common/hooks.ts";

function App() {
  return (
    <RouteProvider>
      <StashItTheme>
        <ConvexClientProvider
          url={ensure(
            import.meta.env.VITE_CONVEX_INTERNAL_URL,
            `missing the process.env.VITE_CONVEX_INTERNAL_URL`,
          )}
        >
          <CommonDialogsProvider>
            <Routes />
            <AppToaster />
          </CommonDialogsProvider>
        </ConvexClientProvider>
      </StashItTheme>
    </RouteProvider>
  );
}

// On paper like everything else, and above the bottom nav on a phone
const AppToaster = () => {
  const { scheme } = useAppearance();
  const isSm = useIsSm();
  return (
    <Toaster
      theme={scheme}
      closeButton={true}
      position={"bottom-center"}
      offset={isSm ? 86 : 24}
      toastOptions={{
        style: {
          background: "var(--paper)",
          color: "var(--ink)",
          border: "1px solid var(--line)",
          fontFamily: "var(--sans)",
        },
      }}
    />
  );
};

export default App;
